export default __webpack_public_path__ + "static/media/1.107dff93.png";